import React from 'react';
import { connect } from 'react-redux';
import { getGlyphe, toDate } from '../../App_Code/Utils';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Tableau from '../Tableau';

const AlertePasDeNews = () => (
    <div className="jumbotron text-center">
        <h1 className="display-4">Il n&apos;y a pas de news pour cette copropriété.</h1>
    </div>
);

const BadgeAct = ({ Act }) =>
    Act === 'NEWSCS' && (
        <span
            className="badge badge-pill badge-cs"
            title="Seuls les membres du conseil syndical peuvent voir ce message"
        >
            CS
        </span>
    );

const PageNews = ({ LsNews, history }) => {
    if (!LsNews || LsNews.length === 0) return <AlertePasDeNews />;

    const Entete = (
        <tr>
            <th scope="col">Date</th>
            {/* <th scope="col">De</th> */}
            <th scope="col">Libellé</th>
            <th scope="col" colSpan="2">
                Infos
            </th>
        </tr>
    );

    const Lignes = LsNews.map((news, i) => (
        <tr
            className="clickable-row"
            key={i}
            onClick={() =>
                history.push({
                    pathname: '/MaCopropriete/News/Message',
                    state: { Mes: news, isNews: true },
                })
            }
        >
            <td>{toDate(news.DateSaisie, 'DD/MM/YYYY HH:mm')}</td>
            {/* <td>
                <img src={getGlyphe(news.Util1)} alt={news.Util1.Nom} /> {news.Util1.Nom}
            </td> */}
            <td>{news.Objet}</td>
            <td>{news.LsFichiers.length > 0 && <i className="fas fa-paperclip" />}</td>
            <td>
                <BadgeAct Act={news.Act} />
            </td>
        </tr>
    ));

    return <Tableau Entete={Entete} Lignes={Lignes} />;
};
PageNews.displayName = 'PageNews';
PageNews.requiredProps = [
    'LsNews', // Liste des news
];

function mapStateToProps({
    CopStore: {
        Cop: { LsNews },
    },
}) {
    return { LsNews };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(PageNews));



// WEBPACK FOOTER //
// ./src/components/MaCopro/PageNews.js